import useNode from "../../../../abstract/hook/useNode";
import useStatus from "../../../../abstract/hook/useStatus";
import ChildrenChoice from "../../parameter/ChildrenChoice";
import ChoiceContainer from "../ChoiceContainer";
import ChoiceHeader from "../ChoiceHeader";
import ChoiceMain from "../ChoiceMain";
import ChoicePanel from "../ChoicePanel";
import ReadOnlyChoiceContainer from "../ReadOnlyChoiceContainer";
import ReadOnlyChoiceHeader from "../ReadOnlyChoiceHeader";
import ReadOnlyChoiceMain from "../ReadOnlyChoiceMain";
import ReadOnlyChoicePanel from "../ReadOnlyChoicePanel";

function ChoiceStructure({ id, readOnly }) {
  const _status = useStatus(id);
  const _node = useNode(id);

  if (readOnly) {
    return <StructureImmutable id={id} node={_node} />;
  } else {
    return <StructureMutable id={id} node={_node} status={_status} />;
  }
}

function StructureImmutable({ id, node }) {
  return (
    <ReadOnlyChoiceContainer node={node}>
      <ReadOnlyChoicePanel />
      <ReadOnlyChoiceMain>
        <ReadOnlyChoiceHeader id={id} element={node}>
          <ChildrenChoice node={node} readOnly />
        </ReadOnlyChoiceHeader>
      </ReadOnlyChoiceMain>
    </ReadOnlyChoiceContainer>
  );
}

function StructureMutable({ id, node, status }) {
  return (
    <ChoiceContainer node={node} status={status}>
      <ChoicePanel node={node} />
      <ChoiceMain node={node}>
        <ChoiceHeader node={node} status={status}>
          <ChildrenChoice node={node} forceView={true} />
        </ChoiceHeader>
      </ChoiceMain>
    </ChoiceContainer>
  );
}

export default ChoiceStructure;
